import $ from 'jquery';

$('.lang-menu__current').on('click', function (e) {
    e.preventDefault();
    $(this).parent().toggleClass('lang-menu--open')
})
